/**
 * DashboardView Component
 *
 * Three-tab dashboard view with overview, regional, and system health panels.
 */

import React from 'react';
import { useStore } from '../store';
import MetricsDashboard from './MetricsDashboard';
import SystemHealthPanel from './SystemHealthPanel';

type DashboardTab = 'overview' | 'health';
type DashboardVariant = 'compact' | 'full';

interface DashboardViewProps {
  variant?: DashboardVariant;
}

const DashboardView: React.FC<DashboardViewProps> = ({ variant = 'compact' }) => {
  const { solverConfig } = useStore();
  const [activeTab, setActiveTab] = React.useState<DashboardTab>('overview');
  const isFull = variant === 'full';

  return (
    <div className={isFull ? 'space-y-6' : 'space-y-4'}>
      {/* Tab navigation */}
      <div className="flex gap-1 bg-gray-800 rounded-lg p-1">
        <button
          onClick={() => setActiveTab('overview')}
          className={`flex-1 py-1.5 px-3 rounded text-xs font-medium transition-colors ${
            activeTab === 'overview'
              ? 'bg-blue-600 text-white'
              : 'text-gray-400 hover:text-white'
          }`}
        >
          Overview
        </button>
        <button
          onClick={() => setActiveTab('health')}
          className={`flex-1 py-1.5 px-3 rounded text-xs font-medium transition-colors ${
            activeTab === 'health'
              ? 'bg-blue-600 text-white'
              : 'text-gray-400 hover:text-white'
          }`}
        >
          System
        </button>
      </div>

      {/* Overview Tab - Metrics Dashboard */}
      {activeTab === 'overview' && (
        <MetricsDashboard
          loadFactor={solverConfig.load_factor}
          refreshInterval={10000}
          variant={variant}
        />
      )}

      {/* System Tab - Health Panel */}
      {activeTab === 'health' && (
        <SystemHealthPanel
          refreshInterval={5000}
          compact={false}
          variant={variant}
        />
      )}
    </div>
  );
};

export default DashboardView;
